export const SOLE_PROPRIETOR = "SoleProprietor";

const legalTypes = [
  { value: "LLP", translationKey: "selectLegalTypeComponent.options.llp.display" },
  { value: SOLE_PROPRIETOR, translationKey: "selectLegalTypeComponent.options.sp.display" },
  { value: "JointStockCompany", translationKey: "selectLegalTypeComponent.options.jsc.display" },
  { value: "PrivateCompany", translationKey: "selectLegalTypeComponent.options.privateCompany.display" },
  { value: "NonProfitOrganization", translationKey: "selectLegalTypeComponent.options.nonProfit.display" },
  { value: "PublicJointStockCompany", translationKey: "selectLegalTypeComponent.options.publicJsc.display" },
];

export const getLegalTypeOptions = (t) =>
  legalTypes.map(({ value, translationKey }) => ({
    value,
    label: t(translationKey),
  }));

export const getRequiredDocumentTypes = (legalType) => {
  if (!legalType) return [];
  return legalType === SOLE_PROPRIETOR ? [0] : [0, 2];
};
